import clsx from "clsx";
import { ReactNode } from "react";

import { Icon } from "../../assets/icons/Icon";
import styles from "./NotificationBlock.module.scss";

type NotificationBlockProp = {
  message?: ReactNode;
  type?: "danger" | "success" | "warning" | "info" | "neutral";
  children?: ReactNode;
  withIcon?: boolean;
  className?: string;
};

const icons = [
  {
    name: "danger",
    component: <Icon iconName="DangerIcon" width="1rem" height="1rem" />,
  },
  {
    name: "warning",
    component: <Icon iconName="WarningIcon" width="1rem" height="1rem" />,
  },
  {
    name: "info",
    component: <Icon iconName="InfoIcon" width="1rem" height="1rem" />,
  },
];

const NotificationBlock = ({
  withIcon = true,
  message,
  type = "info",
  children,
  className,
}: NotificationBlockProp) => {
  const content = children ?? message;

  return (
    <div
      className={clsx(
        styles.notification,
        {
          [styles.warning]: type === "warning",
          [styles.danger]: type === "danger",
          [styles.info]: type === "info",
          [styles.neutral]: type === "neutral",
        },
        className,
      )}
    >
      {withIcon && (
        <div className={styles.notificationIcon}>
          {icons.find((icon) => icon.name === type)?.component}
        </div>
      )}
      <div className={styles.notificationMessage}>{content}</div>
    </div>
  );
};

export default NotificationBlock;
